import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";


interface Props {
    data: any[];
}

export default function ExportXlsxButton({ data }: Props) {

    const { tradePlatform, id } = useParams();
    const {t} = useTranslation();
    const handleExport = () => {
        // Chuyển list -> sheet
        const ws = XLSX.utils.json_to_sheet(data);

        // Tạo workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "History");

        // Xuất file
        const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Lumir_${tradePlatform}_${id}_Trade_History.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <button
            type="button"
            className="_button_rcmwj_3 _type-primary_rcmwj_31 _kind-filled_rcmwj_31 _size-small_rcmwj_266"
            aria-label="show-actions-dropdown-menu"
            aria-haspopup="menu"
            aria-expanded="false"
            data-state="closed"
            data-sentry-element="DropdownMenu.Trigger"
            data-sentry-source-file="MultiActionButton.tsx"
            onClick={() => {
                handleExport();
            }}
        >
            <div className="flex items-center gap-2">
                {t('export')}
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="" data-sentry-element="ArrowDownIcon" data-sentry-source-file="MultiActionButton.tsx">
                    <path d="M12.0001 13.4039L3.95121 6L1 8.71473L12 18.8333L23 8.71483L20.0488 6.0001L12.0001 13.4039Z" fill="currentColor"></path>
                </svg>
            </div>
        </button>
    );
}
